(function () {
  function initWineStorageExplained(root) {
    const section = root.matches('[data-wine-storage-explained]')
      ? root
      : root.querySelector('[data-wine-storage-explained]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const panel = section.querySelector('[data-wine-storage-panel]');
    const toggle = section.querySelector('[data-wine-storage-toggle]');
    const label = toggle?.querySelector('[data-wine-storage-toggle-label]');
    if (!panel || !toggle) return;

    const collapsedHeight = Number(section.dataset.collapsedHeight) || 188;
    const readMore = toggle.dataset.readMore || 'Read more';
    const readLess = toggle.dataset.readLess || 'Read less';

    function contentFitsCollapsed() {
      panel.style.maxHeight = 'none';
      const fits = panel.scrollHeight <= collapsedHeight + 8;
      panel.style.maxHeight = '';
      return fits;
    }

    if (contentFitsCollapsed()) {
      toggle.hidden = true;
      section.querySelector('[data-wine-storage-fade]')?.remove();
      section.classList.add('is-expanded');
      return;
    }

    toggle.addEventListener('click', () => {
      const expanded = !section.classList.contains('is-expanded');
      section.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      if (label) label.textContent = expanded ? readLess : readMore;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wine-storage-explained]').forEach(initWineStorageExplained);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWineStorageExplained(event.target);
  });
})();
